import * as React from "react";
// import { pure } from "recompose";
import * as moment from "moment";
import * as Styled from "@tunnel-components/@sharded/@styled/datepicker/index";
import * as cx from "classnames";
// import * as EnumDatepicker from "@tunnel-enums/datepicker/index";
import CalendarIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import * as Lodash from "lodash";
import * as i18next from "i18next";
moment.locale("en");

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    isSmall,
    error,
    selectedMinutesError,
    selectedSecondsError,
    selectedHoursError,
    isVisible,
    DaysActive,
    onClearDate,
    date,
    onChangeClearDate,
    onSetDayOfMonth,
    onResetDate,
    selected,
    onSetHoursMinutesSeconds,
    placeholder,
    selectedHours,
    selectedSeconds,
    selectedMinutes,
    onShowCalendar,
    onHideCalendar,
    onChangeYearMonth,
  } = props;
  /**
   * @description : tableau contenant le label des Jour de la semaine
   * @const
   * @name labelDays
   * @type { string[]  }
   */
  const labelDays: string[] = [
    i18next.t("LUN"),
    i18next.t("MAR"),
    i18next.t("MER"),
    i18next.t("JEU"),
    i18next.t("VEN"),
    i18next.t("SAM"),
    i18next.t("DIM"),
  ];
  /**
   * @description : tableau contenant les élement de type JSX.element
   * @const
   * @name label
   * @type { any[]  }
   */
  const labels: any[] = [];

  for (let i = 0; i < labelDays.length; i++) {
    labels.push(
      <Styled.DayLabel isSmall={true} key={"key:" + i}>
        {labelDays[i]}
      </Styled.DayLabel>
    );
  }

  // recupération des
  /**
   * @description : la date
   * @const
   * @name date
   * @type { Date }
   */
  const daysInMonth: number = moment(date).daysInMonth();
  const firstDayDate: any = moment(date).startOf("month");
  /**
   * @description : tableau contenant le label des Jour de la semaine
   * @const
   * @name Days
   * @type { any[]  }
   */
  const Days: any[] = [];

  for (let i = firstDayDate.isoWeekday(); i > 1; i--) {
    Days.push(<Styled.Empty key={"i" + i} />);
  }

  for (let i = 1; i <= daysInMonth; i++) {
    Days.push(
      <Styled.DaySpan
        isSmall={true}
        className={cx({ DaysActive: DaysActive[i] })}
        key={"ii" + i}
        onClick={onSetDayOfMonth(i)}
      >
        {" "}
        {i}
      </Styled.DaySpan>
    );
  }

  // recupération des

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @name react-datepicker
   * @infos "https://reactjs.org"
   */

  return (
    <Styled.DatePickerContainer onMouseLeave={onHideCalendar}>
      <Styled.DropDowContainerHeader error={error}>
        <Styled.Input
          style={{ color: "#979797" }}
          onMouseEnter={onShowCalendar}
          onChange={onChangeClearDate}
          value={selected && moment(selected).format("DD/MM/YYYY HH:mm:ss")}
          isSmall={isSmall}
          placeholder={placeholder}
          type="text"
        />
        <Styled.Icon onMouseEnter={onShowCalendar}>
          <CalendarIcon calandar={true} />
        </Styled.Icon>
      </Styled.DropDowContainerHeader>
      <Styled.CalendarContainer
        isSmall={isSmall}
        isVisible={isVisible}
        onMouseLeave={onHideCalendar}
        style={{ top: "35px" }}
      >
        {/** Header */}
        <Styled.CalenderNav className="calendar--nav">
          <Styled.CalendarNavLinkYear isSmall={isSmall}>
            <Styled.IconContainer onClick={onChangeYearMonth(-1, "month")}>
              <CalendarIcon dbArrowRight={true} />
            </Styled.IconContainer>
          </Styled.CalendarNavLinkYear>
          <Styled.CalendarNavLink isSmall={isSmall}>
            <Styled.IconContainer onClick={onChangeYearMonth(-1, "year")}>
              <CalendarIcon arrowRight={true} />
            </Styled.IconContainer>
          </Styled.CalendarNavLink>
          {/** Calendar header */}
          <Styled.CalendarNavHeader onClick={onResetDate}>
            {moment(date).format("MMM").charAt(0).toUpperCase() +
              moment(date).format("MMM").slice(1)}
            {" - "}
            {moment(date).format("YYYY")}
          </Styled.CalendarNavHeader>
          {/** End Calendar header */}
          <Styled.CalendarNavLink isRight={true}>
            <Styled.IconContainer onClick={onChangeYearMonth(1, "year")}>
              <CalendarIcon arrowLeft={true} />
            </Styled.IconContainer>
          </Styled.CalendarNavLink>
          <Styled.CalendarNavLinkYear isSmall={isSmall} isRight={true}>
            <Styled.IconContainer onClick={onChangeYearMonth(1, "month")}>
              <CalendarIcon dbArrowLeft={true} />
            </Styled.IconContainer>
          </Styled.CalendarNavLinkYear>
        </Styled.CalenderNav>

        {/** End Header */}
        {/** Days */}
        <Styled.CalendarDays>
          {labels && labels.concat()}
          {Days && Days.concat()}
        </Styled.CalendarDays>
        {/** End Days */}
        {/** Hours */}

        <Styled.Hours isSmall={isSmall}>
          <Styled.HoursContainer>
            <Styled.Form>
              {i18next.t("heure")}
              <Styled.Label isSmall={isSmall} width={"3px"} />
              <Styled.TimeInput
                disabled={Lodash.isEqual(selected, "")}
                error={selectedHoursError}
                type="text"
                value={selectedHours}
                minLength={0}
                maxLength={2}
                onChange={onSetHoursMinutesSeconds("hours")}
              />
              <Styled.Label isSmall={isSmall} width={"3px"}>
                :
              </Styled.Label>
              <Styled.TimeInput
                disabled={Lodash.isEqual(selected, "")}
                error={selectedMinutesError}
                isSmall={isSmall}
                type="text"
                value={selectedMinutes}
                minLength={0}
                maxLength={2}
                onChange={onSetHoursMinutesSeconds("minutes")}
              />

              <Styled.Label isSmall={isSmall} width={"3px"}>
                :
              </Styled.Label>
              <Styled.TimeInput
                isSmall={isSmall}
                type="text"
                error={selectedSecondsError}
                minLength={0}
                maxLength={2}
                value={selectedSeconds}
                disabled={Lodash.isEqual(selected, "")}
                onChange={onSetHoursMinutesSeconds("seconds")}
              />
              <Styled.Label isSmall={isSmall} width={"3px"} />

              {!Lodash.isEqual(selected, "") && (
                <Styled.Label
                  title={i18next.t("effacer la date")}
                  isSmall={isSmall}
                  width={"3px"}
                  onClick={onClearDate}
                  style={{
                    cursor: "pointer",
                    color: "#ed5b56",
                    fontFamily:
                      "'Lucida Sans Unicode', 'Arial Unicode MS', Arial",
                  }}
                >
                  x
                </Styled.Label>
              )}
            </Styled.Form>
          </Styled.HoursContainer>
        </Styled.Hours>

        {/** End Hours */}
      </Styled.CalendarContainer>
    </Styled.DatePickerContainer>
  );
};

{
  /** INTERFACES */
}

/**
 * @interface
 * @name ComponentInterface
 * @description
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  error?: boolean;
  isSmall?: any;
  isVisible?: any;
  date?: any;
  onShowCalendar?: any;
  onHideCalendar?: any;
  onChangeYearMonth?: any;
  selected?: any;
  onSetHoursMinutesSeconds?: any;
  selectedHours?: any;
  selectedSeconds?: any;
  selectedMinutes?: any;
  onResetDate?: any;
  onSetDayOfMonth?: any;
  DaysActive?: any;
  placeholder?: string;
  onClearDate?: any;
  onChangeClearDate?: any;
  selectedMinutesError?: boolean;
  selectedHoursError?: boolean;
  selectedSecondsError?: boolean;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/dataPicker/component.tsx